module.exports = __webpack_public_path__ + "img/kolfiber.3d70cb06.jpg";